export const API_ENDPOINT = "/api/v1/mcd";
export const AZURE_ENDPOINT = "/api/v1/mcd/status/isAzure";
export const ORGANIZATION_STRUCTURE_ENDPOINT =
  "/api/v1/mcd/data/getOrganizationStructure";
export const CREATE_SURVEY_ENDPOINT = "/api/v1/mcd/data/createSurvey";
export const MS_GRAPH_ME_ENDPOINT = "https://graph.microsoft.com/v1.0/me";

export const API_EMW_ENDPOINT = () => {
  if (process.env.REACT_APP_ENV === "DEV") {
    return `${process.env.REACT_APP_EMW_ENDPOINT}/api/v1/emw`;
  }

  return "api/v1/emw";
};

export const WORKER_API_ENDPOINT = "employee/filteredWorkers";
